import { Api } from './api.service';

export const authenticate = (username, password, mfaChallenge, mfaValue) => Api.post('/oauth/token', {
  user_id: username, password, mfa_type: mfaChallenge, mfa_value: mfaValue
});
export const challengeAccepted = (username, password, mfaChallenge) => Api.post('/mfa/challenge_accepted', { user_id: username, password, mfa_type: mfaChallenge });
export const challengeAcceptedNoLogin = (username, uniqueToken, mfaChallenge) => Api.post('/mfa/challenge_accepted_no_login', { user_id: username, unique_token: uniqueToken, mfa_type: mfaChallenge });
export const refreshToken = () => Api.post('/oauth/refresh_token', {});
export const getTOTPDetails = () => Api.get('/mfa/totp_details/');
